import { ConfirmDialog, useToast } from "@nabble/ui";
import { deleteOrganization, type Organization } from "../../../api/adminOrganizations";
import { errorMessage } from "../../../errors";

interface DeleteOrganizationDialogProps {
  /** The organization to delete; null keeps the dialog closed. */
  target: Organization | null;
  onClose: () => void;
  onDeleted: () => void;
}

export function DeleteOrganizationDialog({ target, onClose, onDeleted }: DeleteOrganizationDialogProps): React.JSX.Element {
  const { show } = useToast();

  async function remove(organization: Organization): Promise<void> {
    try {
      await deleteOrganization(organization.id);
      show({ title: "Organization deleted", text: `${organization.name} no longer exists.`, tone: "success" });
      onDeleted();
    } catch (err) {
      show({ title: "We couldn't delete the organization", text: errorMessage(err, "Please try again."), tone: "danger" });
    }
  }

  return (
    <ConfirmDialog
      open={target !== null}
      tone="danger"
      icon="trash"
      title="Delete organization"
      description={target ? `${target.name} will be deleted. This can't be undone.` : undefined}
      confirmLabel="Delete organization"
      onConfirm={() => (target ? remove(target) : undefined)}
      onClose={onClose}
    />
  );
}
